import { render, staticRenderFns } from "./BuyBoxDetails.vue?vue&type=template&id=4ee4f700&scoped=true"
import script from "./BuyBoxDetails.vue?vue&type=script&lang=js"
export * from "./BuyBoxDetails.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./BuyBoxDetails.vue?vue&type=style&index=1&id=4ee4f700&prod&scoped=true&lang=css"
import style2 from "./BuyBoxDetails.vue?vue&type=style&index=2&id=4ee4f700&prod&lang=css"
import style3 from "./BuyBoxDetails.vue?vue&type=style&index=3&id=4ee4f700&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee4f700",
  null
  
)

export default component.exports